import React, { useCallback, useMemo } from 'react';
import { TranslateScope } from '@pegasus/translation';
import { ArticleCarousel, CardsSkeletonLoader, ArticleCompactCard } from '@browsing/components';
import { getCatalogType } from '@browsing/utils';
import { ErrorCard } from './error-card';
import { SeeAllCard } from './see-all';
import * as S from './index.styles';
var getStandardArticleCard = function (carouselItem, index, trackArticleClick, source, recommendedBy, themeHash, catalogType) { return (React.createElement(ArticleCompactCard, { key: carouselItem.sku, brand: carouselItem.brand, campaignIdentifier: carouselItem.campaignIdentifier, catalogType: catalogType, handleOnClick: trackArticleClick(carouselItem, index), media: carouselItem.media, nameCategoryTag: carouselItem.nameCategoryTag, nameColor: carouselItem.nameColor, nameShop: carouselItem.nameShop, navigationSource: source, recommendedBy: recommendedBy, price: carouselItem.price, sku: carouselItem.sku, specialPrice: carouselItem.specialPrice, sustainable: carouselItem.sustainable, energyEfficiencyClass: carouselItem.energy_efficiency_class, energyLabelInfo: carouselItem.energy_label_info, plusBenefit: carouselItem.plusBenefit, plusEarlyAccess: carouselItem.plusEarlyAccess, themeHash: themeHash })); };
var getCarouselItems = function (_a) {
    var carouselItems = _a.carouselItems, trackArticleClick = _a.trackArticleClick, source = _a.source, recommendedBy = _a.recommendedBy, seeAllConfig = _a.seeAllConfig, catalogType = _a.catalogType, themeHash = _a.themeHash;
    if (!(carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.length))
        return [];
    var articleCards = carouselItems.map(function (carouselItem, index) {
        return getStandardArticleCard(carouselItem, index, trackArticleClick, source, recommendedBy, themeHash, catalogType);
    });
    if (seeAllConfig === null || seeAllConfig === void 0 ? void 0 : seeAllConfig.href) {
        articleCards.push(React.createElement(SeeAllCard, { key: "see-all", href: seeAllConfig.href, image: seeAllConfig === null || seeAllConfig === void 0 ? void 0 : seeAllConfig.image, onClick: seeAllConfig === null || seeAllConfig === void 0 ? void 0 : seeAllConfig.onClick, buttontext: seeAllConfig === null || seeAllConfig === void 0 ? void 0 : seeAllConfig.buttontext, titlePosition: (seeAllConfig === null || seeAllConfig === void 0 ? void 0 : seeAllConfig.titlePosition) || 'center' }));
    }
    return articleCards;
};
export var StandardCarousel = function (_a) {
    var _b;
    var carouselItems = _a.carouselItems, loading = _a.loading, error = _a.error, tracking = _a.tracking, translationPath = _a.translationPath, title = _a.title, carouselId = _a.carouselId, seeAllConfig = _a.seeAllConfig, _c = _a.catalogType, catalogType = _c === void 0 ? (_b = getCatalogType()) !== null && _b !== void 0 ? _b : undefined : _c, themeHash = _a.themeHash, _d = _a.textTitle, textTitle = _d === void 0 ? false : _d;
    var source = tracking.source, recommendedBy = tracking.recommendedBy, trackArticleSelection = tracking.trackArticleSelection, trackArticlesView = tracking.trackArticlesView, trackArticlesScroll = tracking.trackArticlesScroll;
    var trackArticleClick = useCallback(function (product, idx) { return function (_e) {
        trackArticleSelection === null || trackArticleSelection === void 0 ? void 0 : trackArticleSelection(product, idx);
    }; }, [trackArticleSelection]);
    var handleIndexInView = useCallback(function (itemsInView) {
        if (trackArticlesView) {
            if (itemsInView.length > 0) {
                var visibleItems = carouselItems.filter(function (_, index) {
                    return itemsInView.includes(index);
                });
                trackArticlesView(visibleItems);
            }
        }
    }, [carouselItems, trackArticlesView]);
    var handleOnScroll = useCallback(function () {
        if (trackArticlesScroll) {
            trackArticlesScroll();
        }
    }, [trackArticlesScroll]);
    var memoizedCarouselItems = useMemo(function () {
        return getCarouselItems({
            carouselItems: carouselItems,
            trackArticleClick: trackArticleClick,
            source: source,
            recommendedBy: recommendedBy,
            seeAllConfig: seeAllConfig,
            catalogType: catalogType,
            themeHash: themeHash,
        });
    }, [
        carouselItems,
        trackArticleClick,
        source,
        recommendedBy,
        seeAllConfig,
        catalogType,
        themeHash,
    ]);
    if (!(carouselItems === null || carouselItems === void 0 ? void 0 : carouselItems.length) && !loading) {
        return null;
    }
    return (React.createElement(TranslateScope, { path: translationPath || '' },
        React.createElement(S.CarouselWrapper, null,
            loading && (React.createElement(S.CardLoaderWrapper, null,
                React.createElement(CardsSkeletonLoader, { width: 185, itemsCount: 6, cardHeight: 320 }))),
            !loading && !error && (React.createElement(ArticleCarousel, { id: carouselId || 'standard-carousel', title: title, textTitle: textTitle, isOverflowCarousel: true, onSettled: handleIndexInView, onScroll: handleOnScroll }, memoizedCarouselItems)),
            error && React.createElement(ErrorCard, null))));
};
